import React, { useEffect, useState } from "react";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import CAMHeader from "../../../components/Header/CAMHeader";
import CAMSubHeader from "../../../components/Header/CAMSubHeader";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import { action } from "../../../constants/action";
import FiberNewOutlinedIcon from "@mui/icons-material/FiberNewOutlined";

import "./mappingValidation.scss";

import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Tooltip,
  InputBase,
  Button,
  TextField,
  Tab,
  Chip,
  Stack,
} from "@mui/material";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as acts from "../../../redux/investigation/actions";

import TablePagination from "@mui/material/TablePagination";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";
import ProgressBar from "../../../components/ProgressBar";
import ActionBar from "../../../components/Actionbar/ActionBars";
import moment from "moment";
import { updateType } from "../../../redux/mapping/actions";
import Label from "../../../components/Label/Label";

const MappingValidationList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const apiStatus = useSelector((state) => state?.investigation?.apiStatus);
  // const apiStatusMapping = useSelector(
  //   (state) => state?.investigation?.apiStatus,
  // );
  const batch_details = useSelector(
    (state) => state?.investigation?.mappingBatchDetails,
  );
  const type = "batch";

  const [openRows, setOpenRows] = useState({});
  const [pageCount, setPageCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [page, setPage] = useState(0);
  // const [projects, setProjects] = useState([]);

  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [loader, setLoader] = useState(false);
  const [success, setSuccess] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [drugType, setDrugType] = useState(null);

  const DEBOUNCE_MS = 400;

  const header = ["Project", "Status", "End Date", "Last Updated (UTC)", "Action"];

  // Column widths — Action gets a fixed px width, remaining 4 columns share
  // the rest proportionally. Adjust the % split if a column looks cramped.
  const actionColWidth = "120px";
  const dataColWidths = ["40%", "18%", "18%", "18%"]; // Project, Status, End Date, Last Updated

  useEffect(() => {
    dispatch(updateType("project"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(
      acts.getMappingBatchDetailsList({
        type: type,
        formattedStartDate: "",
        formattedEndDate: "",
        status: "",
        reviewFor: "mapping",
        searchText: "",
        drugType: "",
      }),
    );
  }, [dispatch]);

  // useEffect(() => {
  //   // if (projectFromState?.length > 0) {
  //   setProjects(batch_details?.batches_for_review);
  //   // }
  // }, [type]);

  // useEffect(() => {
  //   if (batch_details?.batches_for_review?.length > 0) {
  //     setProjects(batch_details.batches_for_review);
  //     setPageCount(batch_details.total_count || 0);
  //   } else {
  //     setProjects([]);
  //     setPageCount(0);
  //   }
  // }, [batch_details]);

  useEffect(() => {
    if (!apiStatus) return;

    if (apiStatus?.apiError) {
      setLoader(false);
      setMessage(apiStatus?.message || "Something went wrong");
      setErr(true);
    } else if (apiStatus?.apiSuccess) {
      setLoader(false);
      dispatch(acts.clearApiStatus());
    }
  }, [apiStatus, dispatch]);

  // useEffect(() => {
  //   const t = setTimeout(() => {
  //     // dispatch here only when searchText changes and after debounce
  //     dispatch(
  //       acts.getMappingBatchDetailsList({
  //         page: 1,
  //         page_size: rowsPerPage,
  //         search: searchText,
  //       })
  //     );
  //     setPage(0);
  //   }, DEBOUNCE_MS);

  //   return () => clearTimeout(t); // cleanup on change/unmount
  // }, [searchText, dispatch]);

  const toggleRow = (projectId) => {
    setOpenRows((prev) => ({
      ...prev,
      [projectId]: !prev[projectId],
    }));
  };

  const onClickValidate = (projectId, projectName, forValue) => {
    navigate(`/validate-mapping`, {
      state: { projectId, projectName, forValue: forValue },
    });
    localStorage.setItem("projectName", projectName);
    localStorage.setItem("projectId", projectId);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newVal = parseInt(event.target.value, 10) || 100;
    setRowsPerPage(newVal);
    setPage(0);
  };

  const onSearch = (word, type) => {
    setSearchText(word);
    // let result;
    // let filteredProjects = [];

    // if (
    //   !batch_details?.batches_for_review ||
    //   !Array.isArray(batch_details?.batches_for_review)
    // ) {
    //   setProjects([]);
    //   return;
    // }

    // if (type === "project") {
    //   if (word) {
    //     result = batch_details?.batches_for_review?.filter(function (el) {
    //       return (
    //         el?.project_name
    //           .toString()
    //           .toLowerCase()
    //           .indexOf(word.toLowerCase()) !== -1
    //       );
    //     });
    //   } else {
    //     result = batch_details?.batches_for_review;
    //   }
    // } else {
    //   if (word) {
    //     batch_details?.batches_for_review?.map((item, index) => {
    //       const filteredBatches = item?.batch_info?.filter(function (el) {
    //         return (
    //           el?.batch_name
    //             .toString()
    //             .toLowerCase()
    //             .indexOf(word.toLowerCase()) !== -1
    //         );
    //       });
    //       if (filteredBatches.length > 0) {
    //         filteredProjects.push({
    //           ...batch_details?.batches_for_review[index],
    //           batch_info: filteredBatches,
    //         });
    //       } else {
    //       }
    //     });
    //     result = filteredProjects;
    //   } else {
    //     result = batch_details?.batches_for_review;
    //   }
    // }
    // setProjects([...result]);
  };

  const filterByDate = (startDate, endDate, status) => {
    const formattedStartDate =
      startDate !== "" ? moment(startDate).format("YYYY-MM-DD") : "";
    const formattedEndDate =
      endDate !== "" ? moment(endDate).format("YYYY-MM-DD") : "";

    dispatch(
      acts.getMappingBatchDetailsList({
        type,
        formattedStartDate,
        formattedEndDate,
        status,
        reviewFor: "mapping",
        searchText: searchText,
        drugType: drugType,
      }),
    );
  };

  const clear = () => {
    setSearchText("");
    setDrugType(null);

    dispatch(
      acts.getMappingBatchDetailsList({
        type: type,
        formattedStartDate: "",
        formattedEndDate: "",
        status: "",
        reviewFor: "mapping",
        searchText: "",
        drugType: "",
      }),
    );
  };

  const projects = batch_details?.batches_for_review || [];

  return (
    <>
      <CAMHeader />
      <CAMDrawer />
      <InvestigatorContainer>
        {/* <CAMSubHeader text={action.DATA_VALIDATION} /> */}

        <div className="mapping-validation-wrap">
          <div style={{ paddingTop: "10px" }}>
            <ActionBar
              onSearch={(value, type) => onSearch(value, type)}
              filterByDate={filterByDate}
              clear={clear}
              diasableBatchOptions={true}
              // onClickViewPendingBatches={onClickViewPendingBatches}
              // list={list}
              searchText={searchText}
              drugType={drugType}
              setDrugType={setDrugType}
              approvalFor="mappingApproval"
            />
            {/* <Grid container className="search-wrap">
            <Grid item md={4}>
              <TextField
                placeholder={action.SEARCH_BATCH}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                size="small"
                label={action.SEARCH_BATCH}
              />
            </Grid>
          </Grid> */}
          </div>

          <Box
            className="mapping-validation-table-wrap"
            style={{ paddingTop: "10px" }}
          >
            {apiStatus?.loader ? (
              <DashboardTableSkaleton />
            ) : (
              <Box className="mapping-validation-table-container">
                <TableContainer className="mapping-validation-container">
                  <Table
                    stickyHeader
                    className="mapping-validation-info-table"
                    sx={{ tableLayout: "fixed" }}
                  >
                    <colgroup>
                      {dataColWidths.map((w, idx) => (
                        <col key={`ol-${idx}`} style={{ width: w }} />
                      ))}
                      <col style={{ width: actionColWidth }} />
                    </colgroup>

                    <TableHead>
                      <TableRow>
                        {header.map((col, index) => (
                          <TableCell key={col} sx={{ pl: index === 0 ? 4 : 2 }}>
                            {col}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {projects?.length > 0 ? (
                        projects?.map((project, i) => {
                          const isOpen = openRows[project?.project_id];

                          return (
                            <React.Fragment
                              key={
                                project?.project_id ??
                                project?.project_name ??
                                i
                              }
                            >
                              {/* Project Row */}
                              <TableRow>
                                {/* <TableCell>
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      toggleRow(project?.project_id)
                                    }
                                  >
                                    {isOpen ? (
                                      <KeyboardArrowUpIcon />
                                    ) : (
                                      <KeyboardArrowDownIcon />
                                    )}
                                  </IconButton>
                                </TableCell> */}
                                <TableCell
                                  sx={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: 1,
                                  }}
                                >
                                  {/* Fixed space for NEW icon */}
                                  <Box
                                    sx={{
                                      width: 24, // reserve space
                                      minWidth: 24,
                                      display: "flex",
                                      justifyContent: "center",
                                      marginTop: "2px",
                                    }}
                                  >
                                    {project?.mapping_review_status ===
                                      "assigned" && (
                                      <FiberNewOutlinedIcon className="new-icon" />
                                    )}
                                  </Box>

                                  {/* Project details */}
                                  <Box className="p-name">
                                    <div>{project.project_name}</div>

                                    <Stack
                                      direction="row"
                                      className="drugType-wrap"
                                    >
                                      <Chip
                                        label={project.drug_type}
                                        className="drugType"
                                      />

                                      <Label
                                        fontSize={12}
                                        fontWeight={500}
                                        text={
                                          project.project_type === "both"
                                            ? "QC & AE"
                                            : project.project_type ===
                                                "parameter_extraction"
                                              ? "AE"
                                              : project.project_type ===
                                                  "qc_extraction"
                                                ? "QC"
                                                : ""
                                        }
                                        padding="0px 0px 0px 5px"
                                      />
                                    </Stack>
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  <Label
                                    text={project.mapping_review_status?.replace(
                                      /_/g,
                                      " ",
                                    )}
                                    fontWeight={500}
                                  />
                                </TableCell>
                                <TableCell>
                                  {project.mapping_review_end_date}
                                </TableCell>

                                <TableCell>{project.updated_on}</TableCell>
                                <TableCell>
                                  {/* <Tooltip title="Validate"> */}
                                  <Button
                                    size="small"
                                    style={{ minWidth: "100px" }}
                                    onClick={() =>
                                      onClickValidate(
                                        project?.project_id,
                                        project.project_name,
                                        project.mapping_review_status ===
                                          "approved" ||
                                          project.mapping_review_status ===
                                            "rejected"
                                          ? "viewOnly"
                                          : "validate",
                                      )
                                    }
                                    variant="contained"
                                    // disabled={
                                    //   project.mapping_review_status ===
                                    //   "approved"
                                    // }
                                  >
                                    {project.mapping_review_status ===
                                      "approved" ||
                                    project.mapping_review_status === "rejected"
                                      ? "View"
                                      : "Validate"}
                                  </Button>
                                  {/* </Tooltip> */}
                                </TableCell>
                              </TableRow>

                              {/* Batch Rows */}
                              {/* {isOpen &&
                                Array.isArray(project?.batch_info) &&
                                project.batch_info.map((batch) => (
                                  <TableRow
                                    className="hidden-row"
                                    key={`batch-${batch?.batch_id}`}
                                  >
                                    <TableCell />
                                    <TableCell className="float-right">
                                      {batch?.validation_review_status !==
                                        "approved" && (
                                        <FiberNewOutlinedIcon className="new-icon" />
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      {batch.validation_review_status ===
                                      "approved"
                                        ? "Approved"
                                        : "Draft"}
                                    </TableCell>
                                    <TableCell>
                                      {batch.validation_review_end_date}
                                    </TableCell>
                                    <TableCell>{batch.updated_on}</TableCell>
                                    <TableCell>
                                      <Tooltip title="Validate">
                                        <Button
                                          size="small"
                                          onClick={() =>
                                            onClickValidate(
                                              project?.project_id,
                                              batch?.batch_id,
                                              project.project_name,
                                              batch.batch_name
                                            )
                                          }
                                          variant="contained"
                                          disabled={
                                            batch.validation_review_status ===
                                            "approved"
                                          }
                                        >
                                          Validate
                                        </Button>
                                      </Tooltip>
                                    </TableCell>
                                  </TableRow>
                                ))} */}
                            </React.Fragment>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={header.length + 2} align="center">
                            No records found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}
          </Box>

          {loader && <ProgressBar />}

          {/* <Grid className="pagination-wrap">
            <TablePagination
              component="div"
              rowsPerPageOptions={[100, 200, 300, 500]}
              count={pageCount}
              page={page}
              onPageChange={handlePageChange}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid> */}

          {success && (
            <CustomizedSnackbars
              severity="success"
              state={success}
              text={message}
              handleClose={() => setSuccess(false)}
            />
          )}

          {err && (
            <CustomizedSnackbars
              severity="error"
              state={err}
              text={message}
              handleClose={() => setErr(false)}
            />
          )}
        </div>
      </InvestigatorContainer>
    </>
  );
};

export default MappingValidationList;
